// How often the year plan refreshes its per-week calculation statuses.
//
// A solve runs under a five-minute time budget (the algorithm's `worker.time-budget`), so a status
// change the planner is waiting for is minutes away, not seconds. At 15s the worst-case lag adds
// about 5% to that wait, while a trigger updates its own week immediately without waiting for a
// poll at all.
export const WEEK_STATUS_POLL_INTERVAL_MS = 15_000;

// Status codes that will not fix themselves, so polling stops and the planner is told once instead
// of the page retrying four times a minute forever: the session expired (401), the location's read
// permission was revoked (403), or the scenario is gone / the deployed backend does not have the
// endpoint yet (404).
export const PERMANENT_FETCH_ERROR_STATUS_CODES: readonly number[] = [401, 403, 404];

// Consecutive transient failures back the poll off geometrically — 15s, 30s, 60s, 120s, then hold
// there — so a backend having a bad time is not asked four times a minute indefinitely. Expressed as
// skipped ticks rather than a growing delay, which keeps the timer a plain fixed interval.
export const MAX_POLL_BACKOFF_SKIPPED_TICKS = 7;
